module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('p', {
    staticClass: "C333",
    attrs: {
      "id": "page_v"
    }
  }, [_c('strong', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "C336"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_General_editors__preface#page_vii"
    }
  }, [_vm._v("General editors' preface")])]), _vm._v(" "), _c('p', {
    staticClass: "C336"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Acknowledgements#page_ix"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "C336"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chronology#page_x"
    }
  }, [_vm._v("Chronology")])]), _vm._v(" "), _c('p', {
    staticClass: "C336"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Cue_titles#page_xiii"
    }
  }, [_vm._v("Cue-titles")])]), _vm._v(" "), _c('p', {
    staticClass: "C336"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Introduction#page_xv"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "C337"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Body#page_1"
    }
  }, [_vm._v("SEA AND SARDINIA")])])]), _vm._v(" "), _c('p', {
    staticClass: "C337A"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_I__As_far_as_Palermo#page_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. As far as Palermo")])]), _vm._v(" "), _c('p', {
    staticClass: "C337A"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_II__The_Sea#page_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. The Sea")])]), _vm._v(" "), _c('p', {
    staticClass: "C337A"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_III__Cagliari#page_55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. Cagliari")])]), _vm._v(" "), _c('p', {
    staticClass: "C337A"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_IV__Mandas#page_70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. Mandas")])]), _vm._v(" "), _c('p', {
    staticClass: "C337A"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_V__To_Sorgono#page_84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V. To Sorgono")])]), _vm._v(" "), _c('p', {
    staticClass: "C337A"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_VI__To_Nuoro#page_115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI. To Nuoro")])]), _vm._v(" "), _c('p', {
    staticClass: "C337A"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_VII__To_Terranova_and_the_Steame#page_141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII. To Terranova and the Steamer")])]), _vm._v(" "), _c('p', {
    staticClass: "C337A"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_VIII__Back#page_169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII. Back")])]), _vm._v(" "), _c('p', {
    staticClass: "C336"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Appendix__Maps_of_Sardinia__Sici#page_193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: Maps of Sardinia, Sicily and southern Italy "), _c('em', [_vm._v("(c")]), _vm._v(". 1921)")])]), _vm._v(" "), _c('p', {
    staticClass: "C336"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Explanatory_notes#page_199",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Explanatory notes")])]), _vm._v(" "), _c('p', {
    staticClass: "C336"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Glossary_of_selected_Italian_ter#page_218",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary of selected Italian terms")])]), _vm._v(" "), _c('p', {
    staticClass: "C336"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_A_note_on_pounds__shillings_and#page_239",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A note on pounds, shillings and pence")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-364f7007","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_CONTENTS.vue
// module id = 72
// module chunks = 0